export const authorization = {
  "X-RapidAPI-Host": "coronavirus-monitor.p.rapidapi.com",
  "X-RapidAPI-Key": "68781a08bcmsh8884703f7285062p1d71e1jsnf3468378e101",
};
